export const CHECKOUT_PAGE_SLUG = "checkout";
